import { SxProps } from '@mui/material';
import theme from '@theme/index';

const { palette, spacing } = theme;

const styles: Record<string, SxProps> = {
  label: {
    mt: '2.5rem',
    color: palette.grey.main
  },

  calcResult: {
    color: palette.grey.main,
    mt: spacing(1)
  },

  calcActionBox: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    gap: '1rem',
    width: '100%',
    marginTop: '2.5rem',
    justifyContent: { xs: 'center', sm: 'flex-start' }
  },

  calculatedResultBtn: {
    width: { xs: '100%', md: 'auto' }
  },

  resultText: {
    mt: spacing(1)
  },

  textfield: {
    '& .MuiInput-underline': {
      input: {
        color: palette.grey.main
      },
      '.MuiInputAdornment-root .MuiTypography-root': {
        color: palette.grey.main
      }
    }
  },

  fieldsBox: {
    display: 'flex',
    flexDirection: {
      xs: 'column',
      md: 'row'
    },
    gap: {
      xs: '0rem',
      md: '3rem'
    }
  },

  calculateBtn: {
    mt: '2.5rem',
    width: { xs: '100%', md: 'auto' }
  }
};

export default styles;
